import { render } from "@testing-library/react";
import React from "react";
import { ILegendProps } from "./Legend.types";
import LegendStyles from "./Legend.styles";
import ReportedIcon from "../../../../theme/assets/map-markers/dot_reported.svg";
import NotReportedIcon from "../../../../theme/assets/map-markers/dot_streetlight.svg";
import ExtendedRepairIcon from "../../../../theme/assets/map-markers/dot_extended-repair.svg";
import NonCEIcon from "../../../../theme/assets/map-markers/dot_non-ce.svg";
import { Image } from "react-bootstrap";

const LEGEND: React.FC<ILegendProps> = () => {
  return (
    <LegendStyles.LegendContainer
      data-testid="legend-container"
      className="legend-container"
    >
      <ul>
        <li>
          <Image src={NotReportedIcon} />
          <span>Not Reported</span>
        </li>
        <li>
          <Image data-testid="reported-label" src={ReportedIcon} />
          <span>Reported/In Progress</span>
        </li>
        <li>
          <Image data-testid="extended-repair-label" src={ExtendedRepairIcon} />
          <span>Extended Repair</span>
        </li>
        <li>
          <Image data-testid="non-ce-label" src={NonCEIcon} />
          <span>Other</span>
        </li>
      </ul>
    </LegendStyles.LegendContainer>
  );
};

export default LEGEND;
